import { useState } from 'react';
import '../../App.css';
import './CadastroPage.css';

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import FormCadastro from '../../components/PublicForms/PublicCadastrosForm';

import Cadastro from '../../assets/icons/cadastrar.png';

import CadastrosService from '../../services/CadastrosService';

export default function CadastroPage(){
 
  const [erro, setErro] = useState(null);
  const [retorno, setRetorno] = useState(null);

async function handleSubmitCadastro(payload) { 
  try { 
        setErro(null);
        setRetorno(null);
        const result = await CadastrosService.create(payload); 
        //console.log("Cadastro realizado:", result); 
        setRetorno('Cadastro realizado com sucesso!');
      } catch (error) { 
        console.error("Erro ao cadastrar:", error); 
        setErro(error.response?.data?.message || 'Erro ao realizar Cadastro'); 
        throw error;
      } 
    }

  return (
    <div className="Cadastro-container">
        <Header/>

        <article>
          <div className="Cadastro">
            <div className="Cadastro-header">
              <img src={Cadastro} alt="Cadastro"/>
              Cadastro
            </div>  
            <div className="Cadastro-linha"></div>

              {retorno && (
                <div className="mensagem-sucesso">
                  {retorno}
                </div>
              )}

              {erro && (
                <div className="mensagem-erro">
                  {erro}
                </div>
              )}

            <FormCadastro onSubmit={handleSubmitCadastro} />
          </div>
        </article>
        
        <Footer/>
    </div>
  );  
}